var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.pagination.total_page_count > 1
    ? _c("section", { staticClass: "tc-table-pagination" }, [
        _c(
          "div",
          { staticClass: "pagination-buttons" },
          [
            _c(
              "page-button",
              {
                staticClass: "previous-page",
                attrs: {
                  pagination: _vm.pagination,
                  isLoading: _vm.isLoading,
                  number: _vm.currentPage - 1,
                  isCurrent: () => _vm.currentPage == 1,
                  highlightIfCurrent: false,
                  title: _vm.$gettext("Previous page"),
                },
                on: { jump: _vm.onJump },
              },
              [_c("bulma-icon", { attrs: { name: "fas fa-chevron-left" } })],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "numbered-buttons field has-addons is-centered" },
              [
                _c("div", { staticClass: "field has-addons is-centered" }, [
                  _c("div", { staticClass: "control" }, [
                    _c("span", { staticClass: "pagination-page-status" }, [
                      _vm._v(_vm._s(_vm.pageStatus)),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _vm.pagination.total_page_count > 1
                  ? _c(
                      "div",
                      { staticClass: "field has-addons is-centered" },
                      _vm._l(_vm.nearByPageNumbers, function (pageNumber) {
                        return _c(
                          "div",
                          { key: pageNumber, staticClass: "control" },
                          [
                            _c(
                              "page-button",
                              {
                                attrs: {
                                  pagination: _vm.pagination,
                                  isLoading: _vm.isLoading,
                                  number: pageNumber,
                                  title: _vm.$format(
                                    _vm.$gettext("Jump to page {pageNumber}"),
                                    { pageNumber }
                                  ),
                                },
                                on: { jump: _vm.onJump },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(pageNumber) +
                                    "\n                    "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.pagination.total_page_count > 1
                  ? _c("div", { staticClass: "field has-addons is-centered" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("div", { staticClass: "control" }, [
                        _c(
                          "div",
                          {
                            staticClass: "select jump-to-page",
                            class: {
                              "is-loading":
                                _vm.isLoading &&
                                _vm.jumpMethod == _vm.PageJumpMethod.Dropdown,
                            },
                          },
                          [
                            _c(
                              "select",
                              {
                                attrs: {
                                  disabled: _vm.isLoading,
                                  title: _vm.$gettext("Jump to a page"),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.jump(
                                      _vm.PageJumpMethod.Dropdown,
                                      $event.target.value
                                    )
                                  },
                                },
                              },
                              _vm._l(
                                _vm.pagination.total_page_count,
                                function (pageNumber) {
                                  return _c(
                                    "option",
                                    {
                                      key: pageNumber,
                                      domProps: {
                                        value: pageNumber,
                                        selected:
                                          pageNumber ==
                                          _vm.pagination.current_page_number,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(pageNumber) +
                                          "\n                            "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ]
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c(
              "page-button",
              {
                staticClass: "next-page",
                attrs: {
                  pagination: _vm.pagination,
                  isLoading: _vm.isLoading,
                  number: _vm.currentPage + 1,
                  isCurrent: () =>
                    _vm.currentPage == _vm.pagination.total_page_count,
                  highlightIfCurrent: false,
                  title: _vm.$gettext("Next page"),
                },
                on: { jump: _vm.onJump },
              },
              [_c("bulma-icon", { attrs: { name: "fas fa-chevron-right" } })],
              1
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "control" }, [
      _c("div", { staticClass: "pagination-three-dots" }, [_vm._v("...")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }